/* eslint-disable no-confusing-arrow */
import {
  DeleteOutlined as DeleteOutlinedAntd,
  FormOutlined as FormOutlinedAntd,
  UserOutlined as UserOutlinedAntd,
} from '@ant-design/icons';
import {
  Button as ButtonAntd,
  Card as CardAntd,
  Col as ColAntd,
  DatePicker as DatePickerAntd,
  Spin as SpinAntd,
  Switch as SwitchAntd,
  Table as TableAntd,
  Tag as TagAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

import colors from '../../../../../styles/colors';

export const IncluirNovoLoteButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  padding: 5px 16px 5px 16px;
  border: 1px solid #24a95d;
  border-radius: 2px !important;
  background: #24a95d;

  &:hover,
  &:focus {
    color: #fff;
    border-color: #25b663;
    background-color: #25b663;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-bottom: 1px solid #dfdfdf;
    overflow: auto;
    max-height: 300px;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 14px;
    background: #f5f5f6;
    color: #000000;
    font-family: Roboto;
    font-style: normal;
  }

  table tr > td {
    padding: 4px 16px;
    background: #ffffff;
    color: #000000;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export const ActionButton = styled(ButtonAntd)`
  padding: 0;
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  &:hover {
    color: #6bbc60;
  }
`;

export const DeleteOutlined = styled(DeleteOutlinedAntd)`
  color: #000000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const UserOutlined = styled(UserOutlinedAntd)`
  color: #24a95d;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const FormOutlined = styled(FormOutlinedAntd)`
  color: #000000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

// CARD PARA LISTAGEM
export const Card = styled(CardAntd)`
  height: 100%;
  width: 100%;

  .ant-card-body {
    padding: 12px;
    background-color: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
`;

export const TitleCard = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  font-weight: bold;
`;

export const TextCard = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  font-weight: bold;
`;

export const TextCardColor = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #24a95d;
  font-weight: bold;
`;

// NEW CARD
export const CardVolume = styled(CardAntd)`
  .ant-card-body {
    padding: 24px;
    background: #fafafa;
    border-radius: 2px;
    text-align: center;
  }
`;

export const TitleCardVolume = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #6a6a6a;
`;

export const TextCardVolume = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 22px;
  color: #24a95d;
`;

export const Tag = styled(TagAntd)`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  margin: 0;
  padding-top: 2px;
  padding-bottom: 2px;
  width: 26px;
  height: 23px;
  text-align: center;
`;

export const DirecionamentoWrapper = styled(ColAntd)`
  white-space: nowrap;
  width: 15vw;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  padding: 0;
`;

export const Switch = styled(SwitchAntd)`
  &[aria-checked='true'] {
    background-color: #24a95d;
  }

  &[aria-checked='false'] {
    background-color: #e2e2e2;
  }
`;

export const Col = styled(ColAntd)`
  margin-left: ${props => (props.marginleft ? props.marginleft : 'initial')};
`;

export const DatePicker = styled(DatePickerAntd)`
  max-width: 120px;
  max-height: 32px;
  /* border-color: ${props =>
    props.error ? '#ff4d4f' : '#5DABE4'} !important; */

  /* &:hover, &:focus, &:active {
    box-shadow: ${props =>
      props.error
        ? '0 0 0 2px rgb(255 77 79 / 20%)'
        : '0 0 0 2px rgb(24 144 255 / 20%)'}  !important;
  } */
`;

export const CancelarAgendamentoButton = styled(ButtonAntd)`
  width: 100%;
  height: 32px;
  padding: 5px 16px;

  cursor: pointer;

  border: none;
  border-radius: 2px !important;
  color: ${colors.$light};
  background: ${colors.$auxiliary_berry_14};

  &:hover,
  &:focus {
    color: #fff;
    border-color: #ff7875;
    background-color: #ff7875;
  }
`;

export const SalvarAgendamentoButton = styled.button`
  width: 100%;
  height: 32px;
  padding: 5px 16px;

  cursor: pointer;

  border: none;
  color: ${colors.$brandcolor_primary_dark_green_11};
  background: none;

  :hover {
    opacity: 0.6;
  }

  :disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const Spin = styled(SpinAntd)`
  width: 100%;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;

export const SelectContainer = styled(ColAntd)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  direction: column;
  width: auto;
  height: auto;
  gap: 4px;
`;
